import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, waLink } from "./data";
import { scrollToId } from "./scroll";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header data-testid="site-header" className="fixed inset-x-0 top-0 z-50 px-3 pt-3 sm:px-6">
      <div className={`mx-auto flex max-w-7xl items-center justify-between rounded-full px-4 py-2.5 transition-[background-color,box-shadow] duration-500 sm:px-6 ${scrolled || open ? "bg-arena/85 shadow-[0_10px_40px_-15px_rgba(6,48,31,0.35)] backdrop-blur-xl" : "bg-transparent"}`}>
        <button data-testid="nav-logo" onClick={() => go("top")} aria-label="Inicio">
          <Logo light={!scrolled && !open} />
        </button>
        <nav className="hidden items-center gap-5 xl:flex 2xl:gap-8">
          {NAV.map((n) => (
            <button key={n.id} data-testid={`nav-link-${n.id}`} onClick={() => go(n.id)}
              className={`group relative text-sm font-semibold transition-colors ${scrolled ? "text-selva" : "text-arena"}`}>
              {n.label}
              <span className="absolute -bottom-1 left-0 h-[2px] w-full origin-left scale-x-0 bg-barro transition-transform duration-300 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a data-testid="nav-whatsapp-btn" href={waLink()} target="_blank" rel="noopener noreferrer"
            className="hidden items-center gap-2 rounded-full bg-barro px-5 py-2.5 text-sm font-bold text-white shadow-[0_10px_25px_-10px_rgba(213,43,30,0.7)] transition-transform duration-300 hover:-translate-y-0.5 sm:flex">
            <MessageCircle className="h-4 w-4" /> Hablar con un asesor
          </a>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen((o) => !o)} aria-label="Menú"
            className={`rounded-full p-2.5 xl:hidden ${scrolled || open ? "text-selva" : "text-arena"}`}>
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav data-testid="nav-mobile-menu" initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
            className="mx-auto mt-2 max-w-7xl rounded-3xl bg-arena p-6 shadow-xl xl:hidden">
            {NAV.map((n) => (
              <button key={n.id} data-testid={`nav-mobile-link-${n.id}`} onClick={() => go(n.id)}
                className="block w-full border-b border-selva/10 py-3 text-left font-display text-2xl font-semibold text-selva">
                {n.label}
              </button>
            ))}
            <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="nav-mobile-whatsapp"
              className="mt-5 flex items-center justify-center gap-2 rounded-full bg-mar py-3.5 font-bold text-white">
              <MessageCircle className="h-4 w-4" /> WhatsApp directo
            </a>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
